module.exports = __webpack_public_path__ + "media/images/aloe/icons/line/bag-1593b96a4f22ee439a0f00de84d331f5.svg";